import { useContext } from 'react';
import {
  ProfileReadonlyDocuments,
  VerificationDocuments
} from '@namespace/account';
import { UserContext, useVerifyDocuments } from '@namespace/user';

const ProfileDocuments = ({ id }) => {
  const { verified } = useVerifyDocuments();
  const [user] = useContext(UserContext);
  const { isDefaultRegistratedUser } = user;
  return verified || isDefaultRegistratedUser ? (
    <ProfileReadonlyDocuments id={id} />
  ) : (
    <VerificationDocuments id={id} />
  );
};

export default ProfileDocuments;
